import PhoneNumberListContainer from './containers/PhoneNumberListContainer'

export default PhoneNumberListContainer
